<template>
  <div>
  <div class="row">
    <div class="col-md-3">
      <div class="dash-inner-box">
        <div class="dashboard-heading">
          <h1 class="form-heading">{{eFaculty ? 'Update' : 'Add New'}} Faculty</h1>
        </div>
      <div class="create-fac p10-20">
        <div class="row">
          <form class="facultyForm" id="facultyForm">
            <div class="col-md-12">
              <div class="faculty-Img create-faculty">
                        <span v-if="eFaculty && eFaculty.image">
                            <img v-bind:src="eFaculty.image" id="imgShow" class="imgShow"/>
                          </span>
                <span v-else>
                            <img src="/images/user_avatar.png" id="imgShow" class="imgShow"/>
                          </span>
                <div class="showEdit">
                  <input type="file" id="uploadFacImg" name="image"
                         class="uploadCollegeImg saveField uploadImgs facultyImg"
                         @change="changeFacImg($event)"/>
                  <label for="uploadFacImg">
                    <div class="editIcon">
                      <i class="fas fa-pencil-alt"></i>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <label class="formLabel">Name</label>
              <input type="text" placeholder="Enter Name"
                     @blur="$parent.validateFiled($event)" data-type="isRequired"
                     name="name" class="formTextFields saveField"
                     v-bind:value="`${eFaculty ? eFaculty.faculty_name : ''}`"/>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-12">
              <label class="formLabel">Designation</label>
              <input type="text" placeholder="Enter Designation" v-on:keyup="validateEnterKey"
                     name="designation" v-bind:value="`${eFaculty ? eFaculty.designation : ''}`" class="formTextFields saveField"/>
            </div>
            <div class="col-md-12">
              <label class="formLabel">Department</label>
              <input type="text" placeholder="Enter Department" name="department"
                     v-on:keyup="validateEnterKey" v-bind:value="`${eFaculty ? eFaculty.department : ''}`"
                     class="formTextFields saveField"/>
            </div>
            <div class="col-md-12">
              <label class="formLabel">Experience</label>
              <textarea type="text" placeholder="Enter Experience" v-on:keyup="validateEnterKey" name="experience"
                        v-bind:value="`${eFaculty ? eFaculty.experience : ''}`" class="formTextFields saveField"></textarea>
            </div>
            <div class="col-md-12 tb-btn">
              <button type="button" class="cpe-button" v-if="$parent.notchLoading === 'facultyForm'">
                <i class="fas fa-circle-notch fa-spin fa-fw"></i>
              </button>
              <button type="button" data-type="submit" v-else v-bind:data-id="`${eFaculty ? eFaculty.college_faculty_enc_id : ''}`"
                      @click="addNewFaculty()" >{{eFaculty ? 'Update' : 'Save' }}
              </button>
              <button type="button" class="cp_cancelBtn" data-type="button" v-show="eFaculty" data-id="faculty"
                      @click="$parent.cancelUpdate()" >Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="dash-inner-box">
        <div class="dashboard-heading">
          <h1 class="form-heading">Faculty List</h1>
        </div>
      <div class="grid-container p10-20">
        <div class="grid-item" v-for="f in facultyList">
          <div class="teacher-box">
            <div class="faculty-Img">
                          <span v-if="f.image">
                            <img v-bind:src="f.image" v-bind:id="f.college_faculty_enc_id+'Img'" class="imgShow"/>
                          </span>
              <span v-else>
                            <img src="/images/user_avatar.png" v-bind:id="f.college_faculty_enc_id+'Img'" class="imgShow"/>
                          </span>
            </div>
            <div class="tb-form">
              <h4 class="valueShow text-capitalize">{{ f.faculty_name }}</h4>
            </div>
            <div class="tb-form">
              <p class="valueShow">{{ f.designation }}</p>
            </div>
            <div class="tb-form">
              <p class="valueShow">{{ f.department }}</p>
            </div>
            <div class="tb-form">
              <p class="valueShow">{{ f.experience }}</p>
            </div>
            <div class="actionBtns">
              <button class="removeSch editBtn" v-bind:data-id="f.college_faculty_enc_id" @click="saveFaculty()">
                Edit
              </button>
              <button class="removeSch" v-bind:data-id="f.college_faculty_enc_id" @click="removeFaculty()">
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>

  <div id="imgPreviewModal" class="modal">
    <div class="modal-contents">
      <span class="close" @click="modalClose()">&times;</span>
      <div class="update-course">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <div class="row">
                <div id="preview-img"></div>
              </div>
              <div class="col-md-12 text-center">
                <div class="form-group">
                  <button type="submit" @click="saveCropedImage($event)" class="vanilla-result">Done</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Croppie from "croppie";
import axios from "axios";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {

  name: "Faculty",
  data(){
    return{
      vanilla: null,
      cropedImg: null,
      facultyList: [],
      eFaculty : null,
    }
  },
  mounted() {
    this.getFacultyList();
    let showenImg = document.getElementById('preview-img');
    this.vanilla = new Croppie(showenImg, {
      viewport: {width: 250, height: 250},
      boundary: {width: 300, height: 300},
      showZoomer: true,
      enableOrientation: true,
    });
  },
  methods:{
    addNewFaculty() {
      let btnElem = event.currentTarget;
      let fac_id = btnElem.getAttribute('data-id');
      let parElem = btnElem.closest('div > .teacher-box');
      let facultyForm = parElem.querySelector('.facultyForm');
      let data = this.$parent.createDataObject(facultyForm);
      if(fac_id){
        data.append('faculty_id', fac_id);
      }
      let hasError = facultyForm.querySelector('.hasError');
      if (hasError) {
        return false;
      }
      let self = this;
      self.$parent.notchLoading = 'facultyForm';
      axios.post(`${this.$parent.url}api/v2/college-profile/add-faculty`, data, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              self.$parent.emptyFormFields(facultyForm);
              self.getFacultyList();
              self.eFaculty = '';
              facultyForm.querySelector('img').setAttribute('src', '/images/user_avatar.png');
              self.$parent.notchLoading = null;
            } else {
              self.$parent.notchLoading = null;
              toastr.error('Some error occurred. Try again later', 'Oops!!');
            }
          }
      )
    },
    getFacultyList() {
      let t = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/faculty-list`, {}, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              t.facultyList = response['data']['response']['faculty_list'];
            }
          }
      )
    },
    removeFaculty(){
      let facId = event.currentTarget.getAttribute('data-id');
      let data = {'faculty_id': facId};
      let self = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/remove-faculty`, data, {headers: requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.getFacultyList();
            }
          }
      )
    },
    saveFaculty(){
      let self = this;
      let fac_id = event.currentTarget.getAttribute('data-id');
      let editFac = self.facultyList.filter(
          facultyItem => facultyItem.college_faculty_enc_id == fac_id,
      )
      self.eFaculty = editFac[0];
    },
    modalClose() {
      $('#imgPreviewModal').modal('hide');
    },
    saveCropedImage(ev){
      let t = this;
      let previewDivId = ev.target.getAttribute('data-id');
      let previewDiv = document.getElementById(previewDivId);
      console.log(previewDiv, 'pD');
      t.vanilla.result({
        type: 'base64',
      }).then(function (data){
        let base64Res = data.split(',');
        t.cropedImg = base64Res[1];
        previewDiv.setAttribute('src', data)
        $('#imgPreviewModal').modal('hide');
        ev.target.setAttribute('data-id', '')
      })
    },
    changeFacImg(event) {
      $('#imgPreviewModal').modal('show');
      let t = this;
      let modalCrop = document.querySelector('#imgPreviewModal');
      let clickedElem = event.currentTarget;
      let parElem = clickedElem.closest('.faculty-Img');
      let imgShowId = parElem.querySelector('.imgShow').getAttribute('id');
      modalCrop.querySelector('.vanilla-result').setAttribute('data-id', imgShowId)
      let imgPathUrl = clickedElem.value;
      let imgPath = URL.createObjectURL(event.target.files[0]);
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (!allowedExtensions.exec(imgPathUrl)) {
        alert('Invalid file type');
        return false;
      } else {
        this.vanilla.bind({
          url: imgPath,
        });
      }
    },
    validateEnterKey: function (e) {
      if (e.keyCode === 13) {
        this.getValue(e);
      }
    },
    getValue(event) {
      let clickedInput = event.currentTarget;
      let inputValue = clickedInput.value.trim();
      let tbForm = clickedInput.parentElement.parentElement;
      let rootElem = tbForm.parentElement;
      let valueShow = rootElem.querySelector('.valueShow');
      let facInput = rootElem.querySelector('.facInput');
      if (inputValue) {
        valueShow.innerText = inputValue;
      }
      facInput.classList.remove('facInput-show');
      rootElem.querySelector('.editDetails').style.display = "block";
      valueShow.style.height = "auto";
    },
  }
}
</script>

<style scoped>

</style>